import { Row, Col, Card } from "reactstrap";
import { Progressbar } from "../../../../AbstractElements";
import { SmallProgressBars } from "../../../../Constant";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { SMALL_PROGRESS_DATA, SMALL_PROGRESS_LIST } from "../../../../Data/UiKit/Progress/index";

export const SmallProgressBarsCart = () => {
  return (
    <Col xl="6">
      <Card className="height-equal">
        <CommonCardHeader title={SmallProgressBars} span={SMALL_PROGRESS_DATA} />
        <Row className="card-body progress-showcase progress-b-space">
          <Col>
            <Progressbar color="primary" animated striped bar value="30" className="small-progressbar rounded-pill sm-progress-bar overflow-visible mt-4">
              <span className="txt-primary progress-label">30 MB Data</span>
              <span className="animate-circle"></span>
            </Progressbar>
            {SMALL_PROGRESS_LIST.map(({value,title},index)=>(
              <Progressbar color="primary" animated striped bar value={value} className="small-progressbar rounded-pill sm-progress-bar overflow-visible mt-4" key={index}>
              <span className="txt-primary progress-label">{title}</span>
              <span className="animate-circle"></span>
            </Progressbar>
            ))}
          </Col>
        </Row>
      </Card>
    </Col>
  );
};
